import React from "react";
import {AboutSection} from "../components/about";
import {Showreel} from "../components/showreel";
import {useImages} from "../components/useImages";

const AboutUs =()=>{
    const images = useImages("extras","id")
    return(
        <div className={"page"}>
            <AboutSection />
            <h1 style={{color:'white'}}>See our extra/behind the scenes stuff here!</h1>
            <Showreel slides={images} modules = "cube"/>
        </div>
    );
};

export default AboutUs;